import { render, staticRenderFns } from "./suspendedIcon.vue?vue&type=template&id=d551c5ba&lang=true"
import script from "./suspendedIcon.vue?vue&type=script&lang=js"
export * from "./suspendedIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports